import type { BillingVariant, CreateActivityDTO } from '@/api/dto/activity.dto'

export type ActivityType = 'TOJ' | 'TOJ_CUSTOMER' | 'CONSULTING' | 'TRAINING' | 'PILOT'

export type Activity = {
  readonly id: string
  readonly userId: string
  readonly createdAt: Date | string
  readonly updatedAt: Date | string
  bankId: number
  customerId: number
  type: ActivityType | ''
  date: Date
  location: ActivityLocation
  timeQuantity: number
  billingVariant?: BillingVariant
  notes?: string
  orderId?: number
}

export type ActivityLocation = {
  type: 'onsite' | 'online'
  city?: string
}
export const EMPTY_ACTIVITY: CreateActivityDTO = {
  date: new Date(),
  bankId: 0,
  customerId: 0,
  type: '',
  timeQuantity: 1,
  billingVariant: 'STANDARD',
  activityStartTime: '',
  activityEndTime: '',
  skipTojQuantityCheck: false,
  advisorNumber: '',
  location: { type: 'online' as any, city: '' },
  notes: '',
  contact: '',
  orderId: undefined,
}
